/* tslint:disable:no-parameter-reassignment */
import { CartState, RootState } from '@/store/types';
import { Module } from 'vuex';
import { Step } from '@/cart-page/header/Step';
import { ProductUtil } from '@/services/ProductUtil';
import { Big } from 'big.js';
import { Cart, CartItem } from '@/services/cart/model/cart';
import {OrderDto, ProductDto} from '@eurogast/hub-client-typescript';

export default {
  namespaced: true,
  state: {
    cart: null,
    step: Step.CART,
    lastSuccessfulOrder: null
  },
  getters: {
    getItemBySku(state) {
      return (sku) => {
        if (!state.cart) {
          return null;
        }
        return state.cart.items.find((candidate) => candidate.sku === sku);
      };
    },
    getAllItems(state) {
      return () => {
        return state.cart.items;
      };
    },
    getTotalPrice(state: CartState) {
      return () => {
        return state.cart.items
          .filter((it) => it.product.availability === ProductDto.AvailabilityEnum.ACTIVE)
          .map((cartItem) => ProductUtil.findTotalPriceFor(cartItem))
          .reduce((sum, next) => next ? sum.add(next) : sum, new Big('0.00'));
      };
    }
  },
  actions: {
  },
  mutations: {
    addToLocalCart(state, { cartItem }: {cartItem: CartItem}) {
      const existingItem = state.cart.items.find((candidate) => candidate.sku === cartItem.sku);
      if (existingItem) {
        existingItem.amount = cartItem.amount;
        existingItem.sku = cartItem.sku;
        existingItem.product = cartItem.product;
      } else {
        state.cart.items.push(cartItem);
      }
    },
    setItemPartial(state, cartItem: CartItem) {
      const item = state.cart.items.find((candidate) => candidate.sku === cartItem.sku);
      if (item) {
        item.amount = cartItem.amount || item.amount;
        item.sku = cartItem.sku || item.sku;
        item.unitAbbreviation = cartItem.unitAbbreviation || item.unitAbbreviation;

        if (cartItem.unitAbbreviation && cartItem.product && cartItem.product.units) {
          item.unit = cartItem.product.units.find((e) => e.abbreviation === cartItem.unitAbbreviation);
        }
      }
    },
    setLocalCart(state, { cart }: { cart: Cart }) {
      state.cart = cart;
    },
    setLastSuccessfulOrder(state, { lastSuccessfulOrder }: { lastSuccessfulOrder: OrderDto }) {
      state.lastSuccessfulOrder = lastSuccessfulOrder;
    },
    nextStep(state) {
      state.step++;
    },
    resetCheckoutState(state) {
      state.step = Step.CART;
      state.lastSuccessfulOrder = null;
    }
  }
} as Module<CartState, RootState>;
